import { PlayerParams } from "../types/player";

/**
 * 쿼리스트링의 '0' | '1'의 값을 boolean으로 변환해주는 함수
 * @param {string | null} param param
 */
function setBoolean(param: string | null, initValue: boolean) {
  if (!param) return initValue;
  return param === "1";
}
function setNumber(param?: number | string | null, initValue?: number) {
  const numberParam = Number(param);
  if (!param || isNaN(numberParam)) return initValue;

  return numberParam;
}

/**
 * 쿼리스트링을 파라미터로 변환해주는 함수
 */
export function getPlayerParams(params?: Partial<PlayerParams>): {
  playerParams: PlayerParams;
  debug: { syDebug: boolean };
} {
  const query = new URLSearchParams(window.location.search);

  const id = params?.id ?? query.get("id") ?? "";
  const autoplay = params?.autoplay ?? setBoolean(query.get("autoplay"), false);
  const controls = params?.controls ?? setBoolean(query.get("controls"), true);
  /* BP-5248: 컨트롤바 버튼 개별 숨김. 서로 독립적이며 미지정 시 노출(현행 유지) */
  const fullscreenButton =
    params?.fullscreenButton ??
    setBoolean(query.get("fullscreenButton"), true);
  const muteButton =
    params?.muteButton ?? setBoolean(query.get("muteButton"), true);
  const loop = params?.loop ?? setBoolean(query.get("loop"), false);
  const muted = params?.muted ?? setBoolean(query.get("muted"), true);
  const reaction = params?.reaction ?? setBoolean(query.get("reaction"), false);
  const objectFit =
    params?.objectFit ??
    (query.get("objectFit") as "fill" | "contain" | "cover") ??
    "contain";

  const orgWidth =
    setNumber(params?.orgWidth) ?? setNumber(query.get("orgWidth"));
  const orgHeight =
    setNumber(params?.orgHeight) ?? setNumber(query.get("orgHeight"));
  // const stretch = setBoolean(query.get("stretch"));
  // const ratio = query.get("ratio");

  const playerParams = {
    ...params,
    id,
    autoplay,
    controls,
    fullscreenButton,
    muteButton,
    loop,
    muted,
    reaction,
    objectFit,
    orgWidth,
    orgHeight,
  };

  const syDebug = query.get("sy_debug") === "true";
  const debug = {
    syDebug,
  };
  return { playerParams, debug };
}
